import { range } from "lodash";
import { TableColumn } from "PFApp/components/table/table_types";
import { Icon } from "PFComponents/icon";
import Tooltip from "PFComponents/tooltip/tooltip";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import css from "./skills_frameworks_table.module.scss";

export const useSkillsFrameworksListColumns = () => {
  const { t } = useTranslation("skillsFrameworks");

  const columns = useMemo<TableColumn[]>(
    () => [
      {
        locked: true,
        orderKey: "skills_framework_templates.name",
        name: "name",
        title: "skillsFrameworks:list.table.headers.name",
        size: 2,
        type: "text",
        isDefault: true,
        attribute: ["name"]
      },
      {
        locked: true,
        orderKey: "skills_framework_templates.description",
        name: "description",
        title: "skillsFrameworks:list.table.headers.description",
        size: 2,
        type: "text",
        isDefault: true,
        attribute: ["description"]
      },
      {
        locked: true,
        orderKey: "skills_framework_templates.updated_at",
        name: "lastEdited",
        title: "skillsFrameworks:list.table.headers.lastEdited",
        size: 2,
        type: "date",
        isDefault: true,
        attribute: ["updatedAt"]
      },
      ...range(4).map(
        (index) =>
          ({
            locked: true,
            orderKey: "customFields",
            name: `customField#${index + 1}`,
            title: t("list.table.headers.customField", { count: index + 1 }),
            size: 2,
            type: "text",
            isDefault: true,
            attribute: ["customFields", index, "customType"]
          } as TableColumn)
      ),
      {
        orderKey: "skills_framework_templates.values_count",
        name: "skillsCount",
        title: "skillsFrameworks:list.table.headers.skillsCount",
        size: 1,
        type: "text",
        attribute: ["skillsCount"]
      },
      {
        orderKey: "skills_framework_templates.active_profiles_count",
        name: "profilesCount",
        title: "skillsFrameworks:list.table.headers.profilesCount",
        size: 1,
        type: "text",
        attribute: ["activeProfilesCount"]
      },
      {
        name: "insights",
        orderKey: "skills_framework_templates.coverage",
        childrenComponent: (
          <Tooltip content={t("list.table.headers.insightsTooltip")}>
            <span className={css.headerInfoIcon}>
              <Icon name="info" size="sm" />
            </span>
          </Tooltip>
        ),
        title: "skillsFrameworks:list.table.headers.insights",
        size: 2,
        type: "text",
        attribute: ["coverage"]
      }
    ],
    [t]
  );

  return { columns };
};
